/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindWorkScheduleQueryResponse } from './FindWorkScheduleQueryResponse';
import {
    FindWorkScheduleQueryResponseFromJSON,
    FindWorkScheduleQueryResponseFromJSONTyped,
    FindWorkScheduleQueryResponseToJSON,
} from './FindWorkScheduleQueryResponse';
import type { ListMeta } from './ListMeta';
import {
    ListMetaFromJSON,
    ListMetaFromJSONTyped,
    ListMetaToJSON,
} from './ListMeta';

/**
 * 
 * @export
 * @interface ListWorkScheduleQueryResponse
 */
export interface ListWorkScheduleQueryResponse {
    /**
     * 
     * @type {ListMeta}
     * @memberof ListWorkScheduleQueryResponse
     */
    meta: ListMeta;
    /**
     * 
     * @type {Array<FindWorkScheduleQueryResponse>}
     * @memberof ListWorkScheduleQueryResponse
     */
    data: Array<FindWorkScheduleQueryResponse>;
}

/**
 * Check if a given object implements the ListWorkScheduleQueryResponse interface.
 */
export function instanceOfListWorkScheduleQueryResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "meta" in value;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function ListWorkScheduleQueryResponseFromJSON(json: any): ListWorkScheduleQueryResponse {
    return ListWorkScheduleQueryResponseFromJSONTyped(json, false);
}

export function ListWorkScheduleQueryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListWorkScheduleQueryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'meta': ListMetaFromJSON(json['meta']),
        'data': ((json['data'] as Array<any>).map(FindWorkScheduleQueryResponseFromJSON)),
    };
}

export function ListWorkScheduleQueryResponseToJSON(value?: ListWorkScheduleQueryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'meta': ListMetaToJSON(value.meta),
        'data': ((value.data as Array<any>).map(FindWorkScheduleQueryResponseToJSON)),
    };
}

